import { useMemo } from 'react';

import { WordpressData } from '../@types/Wordpress';
import { ContentType } from '../utilities/WordpressConstants';

type UseContentProps = {
  data: WordpressData | null;
  empty: boolean;
  isBlog: boolean;
  isPage: boolean;
};

export const useContentType = ({ data, empty, isBlog, isPage }: UseContentProps) => {
  const contentType = useMemo((): ContentType => {
    if (isPage && !data?.content) {
      return ContentType.ERROR;
    }
    if (isPage) {
      return ContentType.PAGE;
    }
    if (isBlog && empty) {
      return ContentType.EMPTY;
    }
    if (isBlog) {
      return ContentType.BLOG;
    }
    return ContentType.ERROR;
  }, [isPage, data?.content, isBlog, empty]);

  return { contentType };
};
